import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import Editor from '../../../utils/brace'
import { Modal, Form, Row, Col, Input, Select, Button, InputNumber, TimePicker } from 'antd'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {withTranslation} from 'react-i18next'
import {Base64} from 'js-base64'
import moment from 'moment'
const {TextArea} = Input
@inject('dataFlowMonitoringConfigStore')
@observer
class FormModal extends Component {
  state = {
    notificationChannelsValue: '',
    testLoading: false,
    isTested: false,
    groovy: '',
    baseData: {},
    sqlScript: null,
    users: [],
  }

  formRef = React.createRef()
  editorRef1 = React.createRef()
  editorRef4 = React.createRef()

  componentDidMount() {
    const {dataFlowMonitoringConfigStore, title} = this.props
    const {detailsObj, auditLogsUserList} = dataFlowMonitoringConfigStore
    dataFlowMonitoringConfigStore.getNameDropdown({ "dataType": "INBOUND" })
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        'name': detailsObj?.name,
        'type': detailsObj?.type,
        "inboundId": detailsObj?.inboundId.map(a=>a),
        'noticeType': JSON.parse(JSON.stringify(detailsObj?.noticeType)),
        "dingTalkUrl": detailsObj?.dingTalkUrl,
        'users': detailsObj?.users.map(a=>{return parseInt(a?.userId)}),
        'noticeTime': [moment(detailsObj?.noticeTimeStart, 'HH:mm:ss'),moment(detailsObj?.noticeTimeEnd, 'HH:mm:ss')],
        "intervalSecond": detailsObj?.intervalSecond,
        "templateMsg": detailsObj?.templateMsg,
        "scriptType": detailsObj?.scriptType,
        "groovyScript": detailsObj?.scriptType==='groovy' ? JSON.parse(JSON.stringify(detailsObj?.scriptConfig[0]?.script)) : null,
        "groovyList": detailsObj?.scriptType==='sql' ? detailsObj?.scriptConfig.map(a=> {return {...a, script: JSON.parse(JSON.stringify(a?.script))}}) : null,
        'enable': detailsObj?.enable,
      })
      this.setState({
        notificationChannelsValue: detailsObj?.notificationChannelsValue,
        groovy: detailsObj?.scriptType,
        users: detailsObj?.users.map(a=>{
          const obj = auditLogsUserList.find(b=>b?.id===parseInt(a?.userId))
          return {
            "email": obj?.email,
            "phone": obj?.phone,
            "userId": obj?.userId,
            "userName": obj?.userName
          }
        }),
      })
    }
  }

  handleOk = () => {
    const {dataFlowMonitoringConfigStore, handleCancel, title} = this.props
    const {detailsObj} = dataFlowMonitoringConfigStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        // "cron": "string",
        // "enable": 0,
        "id": title === 'edit' ? detailsObj?.id : null,
        "name": fieldsValue?.name,
        "type": fieldsValue?.type,
        "inboundId": fieldsValue?.inboundId,
        "noticeType": fieldsValue?.noticeType,
        "dingTalkUrl": fieldsValue?.dingTalkUrl,
        "users": this.state.users,
        "noticeTimeEnd":  moment(fieldsValue?.noticeTime[1]).format('HH:mm:ss'),
        "noticeTimeStart":  moment(fieldsValue?.noticeTime[0]).format('HH:mm:ss'),
        "intervalSecond": fieldsValue?.intervalSecond,
        "templateMsg": fieldsValue?.templateMsg,
        "scriptType": fieldsValue?.scriptType,
        "scriptConfig": this.state.groovy==='groovy' ? [{script: fieldsValue?.groovyScript}] : fieldsValue?.groovyList,
      }
      if (title === 'edit') {
        dataFlowMonitoringConfigStore.onAddJobAction({...params, id: detailsObj.id}, title)
      } else {
        dataFlowMonitoringConfigStore.onAddJobAction({...params})
      }
      handleCancel()
    }).catch(() => {})
  }

  onChangeGroovy = e => {
    this.setState({
      groovy: e,
      isTested: false
    })
    if(e==='groovy') {
      this.formRef.current.setFieldsValue({
        groovyScript: ''
      })
    } else if (e==='sql') {
      this.formRef.current.setFieldsValue({
        groovyList: [{
          dataSourceId: '',
          script: ''
        }]
      })
    }
  }
  onChangeChannels = e => {
    this.formRef.current.setFieldsValue({
      dingTalkUrl: ''
    })
    if(e.length===0) {
      this.setState({
        notificationChannelsValue: ''
      })
    } else {
      this.setState({
        notificationChannelsValue: e
      })
    }
    this.setState({isTested: false})
  }
  onChangeDataFlowGap = e => {
    this.formRef.current.setFieldsValue({
    })
    this.setState({
      isTested: false
    })
  }

  handleTestConnection = () => {
    const {dataFlowMonitoringConfigStore} = this.props
    const {detailsObj} = dataFlowMonitoringConfigStore
    this.formRef.current.validateFields().then(fieldsValue => {
      this.setState({
        testLoading: true
      })
      let params = {
        // "cron": "string",
        // "enable": 0,
        "id": detailsObj?.id,
        "name": fieldsValue?.name,
        "type": fieldsValue?.type,
        "inboundId": fieldsValue?.inboundId,
        "noticeType": fieldsValue?.noticeType,
        "dingTalkUrl": fieldsValue?.dingTalkUrl,
        "users": this.state.users,
        "noticeTimeEnd":  moment(fieldsValue?.noticeTime[1]).format('HH:mm:ss'),
        "noticeTimeStart":  moment(fieldsValue?.noticeTime[0]).format('HH:mm:ss'),
        "intervalSecond": fieldsValue?.intervalSecond,
        "templateMsg": fieldsValue?.templateMsg,
        "scriptType": fieldsValue?.scriptType,
        "scriptConfig": this.state.groovy==='groovy' ? [{script: fieldsValue?.groovyScript}] : fieldsValue?.groovyList,
      }
      console.log(fieldsValue,'fieldsValue')
      console.log(params,'params')
      dataFlowMonitoringConfigStore.getTextDB(params).then(res => {
        if (res.data.code === 0) {
          this.setState({
            isTested: true,
            testLoading: false
          })
        }
      }).catch(() => [
        this.setState({
          testLoading: false
        })
      ])
    }).catch((err) => {
      console.log(err,'err')
    })
  }
  onChangeUsers = (keys, option) => {
    const {dataFlowMonitoringConfigStore} = this.props
    const {auditLogsUserList} = dataFlowMonitoringConfigStore
    this.setState({
      users: option.map(a=>{
        const obj = auditLogsUserList.find(b=>b?.id===a?.value)
        return {
          "email": obj?.email,
          "phone": obj?.phone,
          "userId": obj?.userId,
          "userName": obj?.userName
        }
      }),
      isTested: false
    })
  }
  parse = (value) => {
    return value ? parseInt(value, 10) : undefined;
  }
 
  // 定义一个方法来格式化输出值
  format = (value) => {
    return value === undefined ? '' : value;
  }
  render() {
    const {dataFlowMonitoringConfigStore, addModalVisible, handleCancel, title, t} = this.props
    const {auditLogsUserList, inBoundNameList, dataSourceList} = dataFlowMonitoringConfigStore
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`dataFlowMonitoringConfig.editJob`) : t(`dataFlowMonitoringConfig.addJob`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          width="70%"
          footer={[
            <Button key="TestConnection" loading={this.state.testLoading} onClick={this.handleTestConnection}>{t(`general.testConnection`)}</Button>,
            <Button key="Save" type="primary" onClick={this.handleOk} disabled={!this.state.isTested}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row gutter={[10, 10]}>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="name" label={t(`dataFlowMonitoringConfig.dataFlowName`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)} ${t(`dataFlowMonitoringConfig.dataFlowName`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\]*$/)
                }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} onChange={() => { this.setState({isTested: false}) }} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="type" label={t(`dataFlowMonitoringConfig.dataFlowType`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataFlowMonitoringConfig.dataFlowType`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch disabled={this.props.title === 'edit'} onChange={() => { this.setState({isTested: false}) }}>
                    <Select.Option key="0" value={0}>{t(`dataFlowMonitoringConfig.realTimeMonitoring`)}</Select.Option>
                    <Select.Option key="1" value={1}>{t(`dataFlowMonitoringConfig.regularMonitoring`)}</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="inboundId" label={t(`dataFlowMonitoringConfig.connection`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataFlowMonitoringConfig.connection`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showArrow mode="multiple" maxTagCount="responsive" maxTagTextLength={10} showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  } onChange={() => { this.setState({isTested: false}) }}>
                    {inBoundNameList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.shortName}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="noticeType" label={t(`dataFlowMonitoringConfig.notificationChannels`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataFlowMonitoringConfig.notificationChannels`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} showArrow allowClear onChange={this.onChangeChannels} mode="multiple" maxTagCount="responsive" maxTagTextLength={10} showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                    <Select.Option key='DING_TALK_ROBOT' value='DING_TALK_ROBOT'>{t(`dataFlowMonitoringConfig.dingding`)}</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              {this.state.notificationChannelsValue !== '' ? <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="dingTalkUrl" label={t(`dataFlowMonitoringConfig.dingdingApiUrl`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)} ${t(`dataFlowMonitoringConfig.dingdingApiUrl`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\]*$/)
                }]}>
                  <Input placeholder={t(`general.pleaseEnter`)} onChange={() => { this.setState({isTested: false}) }} />
                </Form.Item>
              </Col> : null}
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="users" label={t(`dataFlowMonitoringConfig.notificationUser`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataFlowMonitoringConfig.notificationUser`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} showArrow allowClear onChange={this.onChangeUsers} mode="multiple" maxTagCount="responsive" maxTagTextLength={10} showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                    {auditLogsUserList?.map(item => (<Select.Option key={item.userId} value={item.userId}>{item.userName}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="noticeTime" label={t(`dataFlowMonitoringConfig.dataFlowTime`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataFlowMonitoringConfig.dataFlowTime`)}`}]}
                >
                  <TimePicker.RangePicker 
                    style={{width: '100%'}}
                    //defaultValue={[moment(), moment()]}
                    format={'HH:mm:ss'}
                    placeholder={[`${t(`general.pleaseSelect`)} ${t(`apiManagement.start`)}`,`${t(`general.pleaseSelect`)} ${t(`apiManagement.end`)}`]} 
                    onChange={() => { this.setState({isTested: false}) }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item label={<>
                  <span style={{ color: '#ff4d4f', fontSize: '14px', marginRight: '4px', fontFamily: 'SimSun, sans-serif', fontWeight: 'normal' }}>*</span>
                  {t(`dataFlowMonitoringConfig.dataFlowGap`)}
                </>}>
                  <Row gutter={8}>
                    <Col span={20}>
                      <Form.Item name="intervalSecond" style={{marginBottom: 0}}
                        rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataFlowMonitoringConfig.dataFlowGap`)}`}]}
                      >
                        <InputNumber precision={0} min={0} onChange={this.onChangeDataFlowGap} style={{width: '100%'}}
                          formatter={(text) => (/^\d+$/.test(text) ? text : text.slice(0,-1))} // 格式化输出值
                          parser={(text) => (/^\d+$/.test(text) ? text : text.slice(0,-1))} // 解析输入值
                         />
                      </Form.Item>
                    </Col>
                    <Col span={4}><div style={{lineHeight: '32px'}}>s</div></Col>
                  </Row>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                <Form.Item name="templateMsg" label={t(`dataFlowMonitoringConfig.notificationTemp`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataFlowMonitoringConfig.notificationTemp`)}`}]}
                >
                  <Editor
                    ref={this.editorRef1}
                    mode="json"
                    width="100%"
                    height="300px"
                    theme="chrome"
                    enableBasicAutocompletion={false}
                    enableLiveAutocompletion={false}
                    enableSnippets={false}
                    enableEmmet={false}
                    useElasticTabstops={false}
                    setOptions={{useWorker: false}}
                    fontSize="16px"
                    onChange={() => { this.setState({isTested: false}) }}
                  ></Editor>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="scriptType" label={t(`dataFlowMonitoringConfig.groovy`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataFlowMonitoringConfig.groovy`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeGroovy} showSearch >
                    <Select.Option key="groovy" value="groovy">Groovy</Select.Option>
                    <Select.Option key="sql" value="sql">SQL</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              {this.state.groovy==='groovy' ? <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                <Form.Item name="groovyScript" label={t(`dataFlowMonitoringConfig.groovyScript`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataFlowMonitoringConfig.groovyScript`)}`}]}
                >
                  <Editor
                    ref={this.editorRef4}
                    mode="json"
                    width="100%"
                    height="300px"
                    theme="chrome"
                    enableBasicAutocompletion={false}
                    enableLiveAutocompletion={false}
                    enableSnippets={false}
                    enableEmmet={false}
                    useElasticTabstops={false}
                    setOptions={{useWorker: false}}
                    fontSize="16px"
                    onChange={() => { this.setState({isTested: false}) }}
                    //value={sqlScript}
                  ></Editor>
                </Form.Item>
              </Col> : this.state.groovy==='sql' ? <>
                <Form.List name="groovyList">
                  {(fields, { add, remove }) => (
                    <>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                        {fields.map(({ key, name, ...restField }) => (
                          <Row gutter={[10, 0]} key={key} style={{ display: 'flex', marginBottom: 8, width: '100%', background: 'rgba(0,0,0,0.03)' }} align="baseline">
                              <Col xs={24} sm={24} md={6} lg={6} xl={6} xxl={6} span={6}>
                                <Form.Item {...restField}
                                name={[name, 'dataSourceId']} label={t(`dataFlowMonitoringConfig.dbData`)}
                                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataFlowMonitoringConfig.dbData`)}`}]}
                                >
                                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  } onChange={() => { this.setState({isTested: false}) }}>
                                    {dataSourceList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.sourceName}</Select.Option>))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col xs={24} sm={24} md={16} lg={16} xl={16} xxl={16} span={16}>
                                <Form.Item {...restField}
                                name={[name, 'script']} label={t(`dataFlowMonitoringConfig.sqlScript`)}
                                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataFlowMonitoringConfig.sqlScript`)}`}]}
                                >
                                  <Editor
                                    ref={this.editorRef4}
                                    mode="json"
                                    width="100%"
                                    height="300px"
                                    theme="chrome"
                                    enableBasicAutocompletion={false}
                                    enableLiveAutocompletion={false}
                                    enableSnippets={false}
                                    enableEmmet={false}
                                    useElasticTabstops={false}
                                    setOptions={{useWorker: false}}
                                    fontSize="16px"
                                    onChange={() => { this.setState({isTested: false}) }}
                                    //value={sqlScript}
                                  ></Editor>
                                </Form.Item>
                              </Col>
                              <Col xs={24} sm={24} md={2} lg={2} xl={2} xxl={2} span={2} style={{position: 'relative'}}>
                                {fields.length===1 ? null : <MinusCircleOutlined onClick={() => {
                                  remove(name)
                                  this.setState({isTested: false})
                                }} style={{position: 'absolute', top: '50%', left: '50%',}} />}
                                
                              </Col>
                          </Row>
                        ))}
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                        <Form.Item>
                          <Button type="dashed" onClick={() => {
                            add()
                            this.setState({isTested: false})
                          }} block icon={<PlusOutlined />}>
                            {t('general.addData')} {t(`dataFlowMonitoringConfig.dbData`)}
                          </Button>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Form.List>
              </>: null}
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
